import { RbacGateWayInstance } from './axiosInstances/rbac-common.js';

const rbacRequests = {
    getRsaKey() {
        return RbacGateWayInstance.get('/rsa_key');
    },
    postServerLogin(data) {
        return RbacGateWayInstance.post('/server_login', data);
    },
    getLoginMsgCode(data) {
        return RbacGateWayInstance.post(`/messagecode`, data);
    },
    postMobileLogin(data) {
        return RbacGateWayInstance.post(`/mobile_login`, data);
    },
};

export { rbacRequests };
